// src/components/PrivacyPolicy.js
import React from 'react';
import './PrivacyPolicy.css'; // New CSS file for styling

const PrivacyPolicy = () => {
  return (
    <>
      {/* Hero Section */}
      <section className="privacy-hero">
        <div className="container">
          <h1 className="privacy-title">Privacy Policy</h1>
          <p className="privacy-last-updated">Last Updated: January 2026</p>
        </div>
      </section>

      <main className="privacy-main container">
        {/* Navigation Sidebar */}
        <aside className="privacy-sidebar">
          <h4>Navigation</h4>
          <ul>
            <li><a href="#introduction">Introduction / Overview</a></li>
            <li><a href="#information-we-collect">Information We Collect</a></li>
            <li><a href="#how-we-use">How We Use Your Information</a></li>
            <li><a href="#data-sharing">Data Sharing and Disclosure</a></li>
            <li><a href="#security">Security Measures</a></li>
            <li><a href="#cookies">Cookies and Website Analytics</a></li>
            <li><a href="#privacy-rights">Your Privacy Rights</a></li>
            <li><a href="#hipaa">HIPAA Compliance</a></li>
            <li><a href="#childrens-privacy">Children’s Privacy</a></li>
            <li><a href="#policy-changes">Changes to Privacy Policy</a></li>
            <li><a href="#contact">Contact Information</a></li>
            <li><a href="#consent">Consent</a></li>
          </ul>
        </aside>

        {/* Content Sections */}
        <section className="privacy-content">
          <section id="introduction">
            <h2>1. Introduction / Overview</h2>
            <p>
              At Oxymed Billing Solutions, we prioritize your privacy. This Privacy Policy explains how we collect, use, 
              and protect the personal and health-related information of our clients, patients, and website visitors. 
              All practices adhere to HIPAA regulations and industry best practices.

              Our Privacy Policy includes the required "does not share" statement and is publicly accessible from the homepage of our website at https://oxymedbs.com.
            </p>
          </section>

          <section id="information-we-collect">
            <h2>2. Information We Collect</h2>
            <p>Detail the types of information collected. Sub-sections can include:</p>
            <h3>a. Personal Information</h3>
            <p>Name, email, phone number, mailing address, and other identifiers when registering or contacting us.</p>
            <h3>b. Health Information</h3>
            <p>Data related to medical billing and claims strictly for providing our medical billing services.</p>
            <h3>c. Website and Technical Information</h3>
            <p>Cookies, IP addresses, device information, and browsing behavior for analytics and website optimization.</p>
          </section>

          <section id="how-we-use">
            <h2>3. How We Use Your Information</h2>
            <ul>
              <li>Deliver nurse practitioner, urology, or other medical billing services efficiently.</li>
              <li>Communicate updates, service inquiries, or support requests.</li>
              <li>Improve website functionality and service quality through analytics.</li>
              <li>Ensure compliance with HIPAA and other federal or state regulations.</li>
            </ul>
          </section>

          <section id="data-sharing">
            <h2>4. Data Sharing and Disclosure</h2>
            <ul>
              <li>Legal or regulatory obligations.</li>
              <li>Protecting rights, safety, or property of the company or clients.</li>
              <li>Trusted third-party service providers assisting with operations under strict confidentiality agreements.</li>
            </ul>
          </section>

          <section id="security">
            <h2>5. Security Measures</h2>
            <ul>
              <li>Data encryption for storage and transmission.</li>
              <li>Access controls limiting sensitive data to authorized personnel.</li>
              <li>Regular audits and monitoring to ensure compliance with HIPAA and industry standards.</li>
            </ul>
          </section>

          <section id="cookies">
            <h2>6. Cookies and Website Analytics</h2>
            <p>
              Explain the use of cookies and third-party analytics for performance optimization.
              Provide an option to disable cookies with a note about limitations.
            </p>
          </section>

          <section id="privacy-rights">
            <h2>7. Your Privacy Rights</h2>
            <ul>
              <li>Access, correct, or update personal information.</li>
              <li>Request deletion when legally permissible.</li>
              <li>Opt-out of promotional emails.</li>
            </ul>
            <p>Contact Method: Include email and phone for exercising rights.</p>
          </section>

          <section id="hipaa">
            <h2>8. HIPAA Compliance</h2>
            <p>Confirm your adherence to HIPAA guidelines for protecting PHI (Protected Health Information).</p>
            <p>Mention training of staff, secure systems, and confidentiality in billing operations.</p>
          </section>

          <section id="childrens-privacy">
            <h2>9. Children’s Privacy</h2>
            <p>
              State that your website and services are not directed to children under 13. 
              You do not knowingly collect data from minors.
            </p>
          </section>

          <section id="policy-changes">
            <h2>10. Changes to Privacy Policy</h2>
            <p>Notify users that updates may occur periodically. Include “effective date” and encourage checking the page for updates.</p>
          </section>

          <section id="contact">
            <h2>11. Contact Information</h2>
            <p>Email: info@oxymedbs.com</p>
            <p>Website: oxymedbs.com</p>
            <p>Oxymed Billing Solutions</p>
          </section>

          <section id="consent">
            <h2>12. Consent</h2>
            <p>
              Clearly state that by using the website or services, users consent to the practices described in the Privacy Policy.
            </p>
          </section>
        </section>
      </main>

      {/* Footer Section */}
    </>
  );
};

export default PrivacyPolicy;